var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublishIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 78C60.5391 78 78 60.5391 78 39C78 17.4609 60.5391 0 39 0C17.4609 0 0 17.4609 0 39C0 60.5391 17.4609 78 39 78Z",
    fill: "url(#paint0_linear_630_55059)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2703 48.4633H22.7297C20.4867 48.4633 18.6621 50.2855 18.6621 52.5256V57.9418C18.6621 60.1819 20.4867 62.0041 22.7297 62.0041H55.2703C57.5133 62.0041 59.3379 60.1819 59.3379 57.9418V52.5256C59.3379 50.2855 57.5133 48.4633 55.2703 48.4633ZM25.4414 56.5877C24.6926 56.5877 24.0855 55.9813 24.0855 55.2335C24.0855 54.4856 24.6926 53.8795 25.4414 53.8795C26.1902 53.8795 26.7973 54.4856 26.7973 55.2335C26.7973 55.9813 26.1902 56.5877 25.4414 56.5877ZM30.8648 56.5877C30.1161 56.5877 29.509 55.9813 29.509 55.2335C29.509 54.4856 30.1161 53.8795 30.8648 53.8795C31.6136 53.8795 32.2207 54.4856 32.2207 55.2335C32.2207 55.9813 31.6136 56.5877 30.8648 56.5877ZM36.2883 56.5877C35.5395 56.5877 34.9324 55.9813 34.9324 55.2335C34.9324 54.4856 35.5395 53.8795 36.2883 53.8795C37.0371 53.8795 37.6441 54.4856 37.6441 55.2335C37.6441 55.9813 37.0371 56.5877 36.2883 56.5877ZM30.8648 29.5064H34.9324V38.9848C34.9324 39.7333 35.5389 40.3388 36.2883 40.3388H41.7117C42.4611 40.3388 43.0676 39.7331 43.0676 38.9848V29.5063H47.1352C47.6489 29.5063 48.1176 29.2167 48.348 28.7578C48.5771 28.299 48.528 27.7502 48.2195 27.3403L40.0844 16.5079C39.5733 15.8255 38.4266 15.8255 37.9156 16.5079L29.7805 27.3403C29.472 27.7502 29.4229 28.299 29.652 28.7578C29.8824 29.2168 30.3511 29.5064 30.8648 29.5064ZM41.7117 43.047H36.2883C35.5389 43.047 34.9324 43.6526 34.9324 44.4011C34.9324 45.1495 35.5389 45.7551 36.2883 45.7551H41.7117C42.4611 45.7551 43.0676 45.1494 43.0676 44.4011C43.0676 43.6526 42.4611 43.047 41.7117 43.047Z",
    fill: "url(#paint1_linear_630_55059)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_630_55059",
    x1: 39,
    y1: 78,
    x2: 39,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_630_55059",
    x1: 39,
    y1: 62.0039,
    x2: 39,
    y2: 15.9961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5558FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishIcon);
export default __webpack_public_path__ + "static/media/publish-icon.c1b172bf16bce3fd2ed581af36d77703.svg";
export { ForwardRef as ReactComponent };